import FDictionary from '../__select';
import Form from './Form';

export default class FDictionaryServiceAdditional extends FDictionary {
  dictionary = 'additionalService';

  permissionAdd = [114];

  constructor(props) {
    super(props);
    if (props.service) {
      this.service = props.service;
    }
    if (props.country) {
      this.country = props.country;
    }
    if (props.city) {
      this.city = props.city;
    }
  }

  get service() {
    return this.refs.data.service;
  }

  set service(value) {
    if (!value) {
      return;
    }
    this.refs.data.service = value;
    this.refs.set('service', value);
  }

  get country() {
    return this.refs.data.country;
  }

  set country(value) {
    if (!value) {
      return;
    }
    this.refs.data.country = value;
    this.refs.set('country', value);
    if (this.city) {
      this.city.country = this.country;
    }
  }

  get city() {
    return this.refs.data.city;
  }

  set city(value) {
    if (!value) {
      return;
    }
    this.refs.data.city = value;
    this.refs.set('city', value);
    if (this.country) {
      this.city.country = this.country;
    }
  }

  getOptions(model = this.refs.data) {
    if (!model.country || !model.service) {
      return Promise.resolve(this.setOptions([]));
    }
    return super.getOptions(model);
  }

  addForm() {
    const item = new Form();
    if (this.service) {
      item.service.set(this.service);
      item.service.disabled = true;
    }
    if (this.country) {
      item.country.set(this.country);
      item.country.disabled = true;
    }
    if (this.city) {
      item.city.set(this.city);
      item.city.disabled = true;
    }
    item.init();
    return item;
  }
}
